import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AddToGroup from 'app/components/AddToGroup';
import Prompt from 'app/components/Prompt';
import Confirm from 'app/components/Confirm';
import { defaultGroupId, MAIN_CONTEXT } from 'reducers';
import ContactSearchTable from 'app/components/SearchTable/ContactSearchTable';
import { contactGroupPath } from 'app/routes';
import MailingLabelsPopup from 'app/components/MailingLabels';
import RenameListModal from '../../components/RenameListModal';
import {
  saveGroupContext,
  selectLoading,
  selectAssignableGroups,
  ContactGroupTypes,
  selectGroupContext,
  exportContacts,
  updateAppendJob,
  updateContactGroup,
  getSearch,
  searchContactIds,
} from 'data/contacts';
import { selectPabEnabled, selectProfile, selectListManagementEnabled } from 'data/user';
import { selectBatchDialerList, selectUserId, isLegacyAccountPlan } from 'data/user/selectors';
import {
  getBatchDialerIntegration,
  setBatchDialerSource,
  createDialerCampaign,
  openLeadAutomatorUpgrade,
} from 'data/user/actions';
import { loadCampaign, loadCampaigns } from 'data/campaigns/actions';
import CampaignActivitySettingsModal, {
  CAMPAIGN_ACTIVITY_SETTINGS_CONTEXT,
  CAMPAIGN_ACTIVITY_TYPE,
} from 'app/Campaigns/CampaignActivitySettingsModal';
import FullAccessRequiredModal from 'components/ClickToDial/FullAccessRequiredModal/FullAccessRequiredModal';
import LeadAutomatorUpgrade from 'components/DialerCampaign/LeadAutomatorUpgrade/LeadAutomatorUpgrade';
import { checkDialerCampaignAccess } from '../../Campaigns/dialerCampaignAccess';
import PushtoBatchDialer from '../../../components/PushtoBatchDialer';
import BatchDialerModal from '../../components/BatchdialerModal';
import ClickToDial from '../../../components/ClickToDial';
import BatchDialerAlert from '../../components/BatchdialerAlert';
import ContactImport from '../ContactImport';

import SkipTraceModal from 'app/components/SkipTraceModal';
import InvestorSkipTraceModal from 'app/components/InvestorSkipTraceModal';
import InfoAlert from '../../components/InfoAlert';
import { getAppendJobEstimate } from '../../../data/contacts/actions';
import { selectAppendGroups } from '../../../data/contacts';

import { isPropStream } from '../../../utils/brand';
import AddToMarketingListModal from 'app/components/AddToMarketingListModal';
import LeaveMessagePopup from '../../AccountNew/modals/LeaveMessage';
import ActivateSubscriptionPopup from '../../AccountNew/modals/ActivateSubscription';
import PurchaseSavesAndExportsPopup from '../../AccountNew/modals/PurchaseSavesAndExports';

import css from './style.scss';
import ContactListControls from '../contactListControls';

class ContactList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isBatchDialerModalOpen: false,
      showRenameModal: false,
      renameConfig: {
        title: '',
        description: '',
        initialValue: '',
        placeholder: '',
        checkOptions: null,
        onSubmit: null,
      },
      showActivitySettingsModal: false,
      pendingActivityType: null,
      pendingContactIds: [],
    };
    this.handleAddToGroupClick = this.handleAddToGroupClick.bind(this);
    this.handleExportClick = this.handleExportClick.bind(this);
    this.handleRenameGroupClick = this.handleRenameGroupClick.bind(this);
    this.handleGenerateMailingLabels = this.handleGenerateMailingLabels.bind(this);
    this.handleSkipTraceClick = this.handleSkipTraceClick.bind(this);
    this.handleSkipTracing = this.handleSkipTracing.bind(this);
    this.handleOpenRenameModal = this.handleOpenRenameModal.bind(this);
    this.handleCloseRenameModal = this.handleCloseRenameModal.bind(this);
    this.handleSaveRename = this.handleSaveRename.bind(this);
    this.handleNewCampaign = this.handleNewCampaign.bind(this);
    this.openCampaignActivitySettingsModal = this.openCampaignActivitySettingsModal.bind(this);
    this.handleModalSave = this.handleModalSave.bind(this);
  }

  componentDidMount() {
    const { userId, getBatchDialerIntegration, profile } = this.props;

    const userType = profile?.get?.('type');

    // If userId is present on mount and user is FULL or TEAM_FULL, initialize batch dialer integration list
    if (userId && (userType === 'FULL' || userType === 'TEAM_FULL')) {
      getBatchDialerIntegration(userId);
    }
  }

  componentDidUpdate(prevProps) {
    const { userId, getBatchDialerIntegration, profile } = this.props;

    const userType = profile?.get?.('type');

    // If userId becomes available (or changes) and user is FULL or TEAM_FULL, re-fetch batch dialer integration info
    if (
      userId &&
      userId !== prevProps.userId &&
      (userType === 'FULL' || userType === 'TEAM_FULL')
    ) {
      getBatchDialerIntegration(userId);
    }
  }

  // Rename Modal Handlers
  handleOpenRenameModal(config) {
    this.setState({
      showRenameModal: true,
      renameConfig: {
        title: config.title || 'Rename',
        description: config.description || config.text || '',
        initialValue: config.initialValue || config.value || '',
        placeholder: config.placeholder || 'Enter name',
        checkOptions: config.checkOptions || null,
        onSubmit: config.onSubmit,
      },
    });
  }

  handleCloseRenameModal() {
    this.setState({ 
      showRenameModal: false,
      renameConfig: {
        title: '',
        description: '',
        initialValue: '',
        placeholder: '',
        checkOptions: null,
        onSubmit: null,
      },
    });
  }

  handleSaveRename(newName, options) {
    const { renameConfig } = this.state;
    if (renameConfig.onSubmit && newName?.trim()) {
      renameConfig.onSubmit(newName.trim(), options);
    }
    this.handleCloseRenameModal();
  }

  handleRenameGroupClick() {
    const { context, updateContactGroup, updateAppendJob } = this.props;
    const groupId = context.get('id');
    const currentName = context.getIn(['info', 'name']);
    const isAppendType = context.getIn(['info', 'type']) === ContactGroupTypes.APPEND;

    // EXACT same logic as original: use .substr(1) to remove first character
    // Original code: context.get('id').substr(1)
    let id = String(groupId);
    if (id.length > 0) {
      id = id.substr(1); // Remove the first character (whether it's 'A', 'C', or any other letter)
    }

    this.handleOpenRenameModal({
      title: 'Rename Group',
      description: 'Please enter a new name for this group.',
      initialValue: currentName,
      placeholder: 'Enter group name',
      onSubmit: (newName) => {
        if (isAppendType) {
          updateAppendJob({ id: id, name: newName });
        } else {
          updateContactGroup({ id: id, name: newName });
        }
      },
    });
  }

  handleAddToGroupClick() {
    const { context, groups, openAddToMarketingListModal, usageSectionDetails, leaveMessagePopup } =
      this.props;
    const { overdueAccount } = this.props.profile;
    const { planDetails } = this.props;
    
    if (overdueAccount) {
      const currentPlan =
        planDetails &&
        planDetails.accountEnrolledPlans &&
        planDetails.accountEnrolledPlans.find((plan) => plan.active);
      const total = currentPlan ? currentPlan.quantity : 0;
      this.props.leaveMessagePopup({
        title: 'Subscription Past Due',
        message: `Your subscription is past due, and no new properties can be saved. Upgrade now to access the full ${total}.`,
        yesLable: 'Upgrade',
        cancelLable: 'Cancel',
        yesRedirect: () => {
          this.props.openAccountUpgrade();
        },
      });
    } else if (usageSectionDetails?.id && usageSectionDetails?.savesRemaining <= 0) {
      leaveMessagePopup({
        title: 'Not Enough Save Credits',
        message:
          "You don't have enough save credits to perform this action. Please purchase additional credits to continue.",
        yesLable: 'Purchase Credits',
        cancelLable: 'Cancel',
        yesRedirect: () => {
          this.props.purchaseSavesAndExportsPopup();
        },
      });
    } else {
      openAddToMarketingListModal({
        title: 'Add to Group',
        groups: groups,
        hideSkipTraceOption: true,
        onSave: (name, onComplete) => {
          const updatedContext = context.setIn(['info', 'name'], name);
          this.props.saveGroupContext(updatedContext, ({ response }) => {
            const savedGroup = response.find((g) => g.modified);
            onComplete(context.get('selected'));
            if (savedGroup?.id) {
              this.props.history.push(contactGroupPath(savedGroup.id));
            }
          });
        },
      });
    }
  }

  handleExportClick() {
    const { exportContacts, context } = this.props;
    exportContacts(context);
  }

  handleViewSummaryClick() {
    const { openAppendJobSummary, context } = this.props;
    const groupId = context.get('id');

    // EXACT same logic as original: use .substr(1)
    let id = String(groupId);
    if (id.length > 0) {
      id = id.substr(1);
    }

    openAppendJobSummary({ appendJobId: id });
  }

  handleGenerateMailingLabels() {
    const { openMailingLabels, context } = this.props;
    openMailingLabels({ contactSearch: getSearch(context) });
  }

  getContactSearch() {
    const { context } = this.props;

    const selection = context.get('selection');
    const allSelected = context.get('allSelected');
    const selected = context.get('selected');

    const selectedArray = Array.isArray(selection) ? selection : selection?.toJS() || {};

    return {
      id: context.get('id'),
      name: context.getIn(['info', 'name']),
      filters: context.get('filters')?.toJS() || [],
      sortModel: context.get('sortModel')?.toJS() || [],
      allSelected,
      selected,
      selectedIds: allSelected
        ? []
        : Array.isArray(selectedArray)
          ? selectedArray
          : Object.keys(selectedArray).filter((k) => selectedArray[k]),
      unselectedIds: allSelected
        ? []
        : Array.isArray(selectedArray)
          ? []
          : Object.keys(selectedArray).filter((k) => !selectedArray[k]),
    };
  }

  openBatchDialerModal = () => {
    const { context, setBatchDialerSource, alert } = this.props;
    const selection = context?.get('selection');
    const selected = context?.get('selected');
    const isAllSelected = context?.get('allSelected');

    if (!selected) {
      if (typeof alert === 'function') {
        alert('Please select the record(s) you would like to add.');
      } else {
        window.alert('Please select the record(s) you would like to add.');
      }
      return;
    }

    setBatchDialerSource('CONTACT');

    if (selection && (isAllSelected || selection.size === context?.get('selected'))) {
      const searchPayload = this.getContactSearch();
      this.setState({
        isBatchDialerModalOpen: true,
        contactSearch: searchPayload,
      });
    }
  };

  closeBatchDialerModal = () => {
    this.setState({ isBatchDialerModalOpen: false });
  };
  
  handleSkipTraceClick() {
    const { context } = this.props;
    const selectedContacts = context.get('data').filter((contact) => contact.get('selected'));
    const selectedContactIds = selectedContacts.toJS().map((contact) => contact['id']);
    const isNoContactSelected = selectedContactIds.length === 0;
    if (isNoContactSelected) {
      this.props.showAlert({
        title: 'No Records Selected',
        infoText: 'Please select one or more records before performing a Skip Trace.',
      });
      return;
    }
    this.handleSkipTracing(selectedContactIds);
  }

  handleSkipTracing(contactIds) {
    const { context } = this.props;
    // Investor List (ATAI-115 / S9) -- these contacts are already members of
    // this list, so the Skip Trace modal opens with that list locked in
    // rather than the classic "Name Your List" job-naming field. See
    // InvestorSkipTraceModal's own header comment for why it's a separate
    // component, not a shared-file edit.
    const isInvestorGroup = context.getIn(['info', 'type']) === ContactGroupTypes.INVESTOR;

    // investorMode: true is required for Investor Lists -- it's what routes
    // this job to the synchronous BATCHDATA_INVESTOR path server-side
    // (ATAI-226, Ps4ContactResource#getAppendJobEstimate). Without it the
    // request falls through to the classic per-property BATCHDATA/Tracers flow.
    this.props.getAppendJobEstimate(
      {
        contactIds,
        appendMode: 'BOTH',
        reprocessEnabled: false,
        ...(isInvestorGroup && { investorMode: true }),
      },
      ({ response, error }) => {
      if (error) {
          console.error('Error fetching estimate:', error);
        return;
      }
      const { message } = response || {};
        if (message?.includes('There is an existing append job')) {
        this.props.showAlert({
            title: 'Skip Trace in Progress',
            infoText:
              'There is a Skip Trace currently in progress. Please try again once it is complete.',
        });
        } else if (isInvestorGroup) {
        this.props.investorSkipTraceModal({
          contactIds,
          initialGroup: { id: context.get('id'), name: context.getIn(['info', 'name']) },
          // This list's already-loaded rows (context.info.data) have no way to
          // pick up the phone/email the append job just wrote -- re-run the
          // group's own search (the "groups api") once the job completes.
          onSuccess: () => this.props.refreshContacts(context),
        });
        } else {
        this.props.skipTraceModal({
          groups: this.props.appendGroups,
          reprocessEnabled: false,
          contactIds,
        });
      }
    }
  );
  }

  // "New Campaign Activity" on the Investor List (ATAI-180 follow-up) —
  // Dialer + Email only, reusing the exact same modal/flow as My Property's
  // "New Campaign Activity" (Property/Group/index.js#handleNewCampaign),
  // adapted to source contact ids from this Contacts group instead of a
  // property search. Same Dialer entitlement gating as Property, so an
  // investor contact can't be used to route around a restriction that
  // applies everywhere else.
  handleNewCampaign(type) {
    const {
      context,
      showAlert,
      profile,
      lmEnabled,
      isLegacyAccount,
      openFullAccessRequiredModal,
      closeFullAccessRequiredModal,
      openLeadAutomatorUpgrade,
      leaveMessagePopup,
      history,
    } = this.props;

    const formatType = (t = '') => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();

    if (!context?.get('selected')) {
      showAlert({
        title: 'No Records Selected',
        infoText: `Please select one or more records before initiating a ${formatType(type)} Campaign.`,
      });
      return;
    }

    if (type === 'DIALER') {
      const allowed = checkDialerCampaignAccess({
        profile,
        lmEnabled,
        isLegacyAccount,
        openFullAccessRequiredModal,
        closeFullAccessRequiredModal,
        openLeadAutomatorUpgrade,
        leaveMessagePopup,
        history,
      });

      if (!allowed) return;

      this.openCampaignActivitySettingsModal(CAMPAIGN_ACTIVITY_TYPE.DIALER);
    } else if (type === 'EMAIL') {
      this.openCampaignActivitySettingsModal(CAMPAIGN_ACTIVITY_TYPE.EMAIL);
    }
  }

  openCampaignActivitySettingsModal(activityType) {
    const { context, searchContactIds, loadCampaigns, showAlert } = this.props;

    // The promise a CALL_API dispatch returns resolves with `undefined`, never
    // the response body (the API middleware resolves its CHAIN_API wrapper with
    // no value), so the contact ids must come from the callbacks — as in My
    // Property's openCampaignActivitySettingsModal (Property/Group/index.js).
    // Reading them off the dispatch promise sent `contactIds: []` on every
    // save, which the dialer endpoint turned into an HTTP 500 (ATAI-420).
    // afterError rejects, so a failed lookup reaches the catch below instead of
    // leaving Promise.all pending; the global error modal is skipped in favour
    // of that alert.
    const contactsPromise = new Promise((resolve, reject) => {
      searchContactIds(
        context,
        ({ response: contactIds }) => resolve(contactIds || []),
        reject,
        true
      );
    });

    Promise.all([contactsPromise, loadCampaigns()])
      .then(([contactIds]) => {
        if (contactIds.length === 0) {
          showAlert({
            title: 'No Leads Found',
            infoText: 'No leads were found for the selected records. Please adjust your selection and try again.',
          });
          return;
        }

        this.setState({
          pendingContactIds: contactIds,
          pendingActivityType: activityType,
          showActivitySettingsModal: true,
        });
      })
      .catch(() => {
        showAlert({
          title: 'Error',
          infoText: 'Could not load campaigns or contacts. Please try again.',
        });
      });
  }

  handleModalSave(name, marketingCampaignId) {
    const { createDialerCampaign, history, showAlert, loadCampaign, context } = this.props;
    const { pendingActivityType, pendingContactIds } = this.state;
    const savedContactGroupId = context.get('id');
    const groupName = context.getIn(['info', 'name']);

    if (pendingActivityType === CAMPAIGN_ACTIVITY_TYPE.DIALER) {
      createDialerCampaign({
        name,
        marketingCampaignId,
        contactIds: pendingContactIds,
        originatingListName: groupName,
      })
        .then((res) => {
          const dialerId = res && res.id;
          if (!dialerId) {
            throw new Error('Invalid dialer response');
          }
          this.setState({
            showActivitySettingsModal: false,
            pendingActivityType: null,
            pendingContactIds: [],
          });
          history.push(`/campaign/${marketingCampaignId}/dialer/${dialerId}`);
          loadCampaign(marketingCampaignId);
        })
        .catch(() => {
          this.setState({
            showActivitySettingsModal: false,
            pendingActivityType: null,
            pendingContactIds: [],
          });
          showAlert({
            title: 'Error',
            infoText: 'Could not create the dialer activity. Please try again.',
          });
        });
    } else if (pendingActivityType === CAMPAIGN_ACTIVITY_TYPE.EMAIL) {
      history.push({
        pathname: `/campaign/${marketingCampaignId}/email/settings`,
        state: { contactIds: pendingContactIds, savedContactGroupId, name, marketingCampaignId },
      });
      this.setState({
        showActivitySettingsModal: false,
        pendingActivityType: null,
        pendingContactIds: [],
      });
    }
  }

  shouldRenderClickToDial() {
    const { profile } = this.props;
    if (!profile) return false;

    const userType = profile?.get?.('type');

    return ['FULL', 'TEAM_FULL', 'TEAM'].includes(userType);
  }

  render() {
    const {
      loading,
      openImport,
      context,
      getContactInfo,
      deleteContacts,
      deleteGroup,
      onDragStart,
      onDragEnd,
      pabEnabled,
    } = this.props;
    const btn = { loading };

    const rawMessage = context.getIn(['info', 'message']);  
    const rawStatus = context.getIn(['info', 'status']);
    const status = rawStatus  === 'ERROR' ? 'Error' : rawStatus === 'COMPLETE' ? 'Complete' : 'Processing';
    const message = rawStatus === 'ERROR' ? (rawMessage === 'Payment declined' ? 'Failed due to card declined.' : 'Failed. Please try again.') : null;
    
    const retrieved = context.get('data').size;
    const size = context.get('size');
    const append = context.getIn(['info', 'type']) === ContactGroupTypes.APPEND;
    const isInvestorGroup = context.getIn(['info', 'type']) === ContactGroupTypes.INVESTOR;
    const selected = context.get('selected');
    const {
      showRenameModal,
      renameConfig,
      showActivitySettingsModal,
      pendingActivityType,
      pendingContactIds,
    } = this.state;

    const profile = this.props.profile;

    const isAdmin = !profile.get('subUser');
    const isTeamMember = profile.get('subUser') && !profile.get('scoutUser');
    const isScoutUser = profile.get('subUser') && profile.get('scoutUser');
    const hasPermission = profile.get('allowPushToBatchDialer');

    const userType = profile?.get?.('type');

    const showPushToBatchDialer =
      userType === 'FULL' || (userType === 'TEAM_FULL' && hasPermission);

    return (
      <div className={css.root}>
        <ContactListControls
          loading={loading}
          selected={selected}
          context={context}
          append={append}
          isInvestorGroup={isInvestorGroup}
          pabEnabled={pabEnabled}
          message={message}
          size={size}
          retrieved={retrieved}
          status={status}
          openImport={openImport}
          isDefaultGroup={context.get('id') !== defaultGroupId}
          handleExportClick={this.handleExportClick}
          handleAddToGroupClick={this.handleAddToGroupClick}
          handleRenameGroupClick={this.handleRenameGroupClick}
          deleteContacts={deleteContacts}
          deleteGroup={deleteGroup}
          handleGenerateMailingLabels={this.handleGenerateMailingLabels}
          handleSkipTraceClick={this.handleSkipTraceClick}
          openBatchDialerModal={this.openBatchDialerModal}
          showPushToBatchDialer={showPushToBatchDialer}
          handleNewCampaign={this.handleNewCampaign}
        />

        <div className={css.body}>
          <ContactSearchTable
            context={context}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            fullMode
          />
        </div>

        <CampaignActivitySettingsModal
          isOpen={showActivitySettingsModal}
          onClose={() =>
            this.setState({
              showActivitySettingsModal: false,
              pendingActivityType: null,
              pendingContactIds: [],
            })
          }
          activityType={pendingActivityType}
          context={CAMPAIGN_ACTIVITY_SETTINGS_CONTEXT.MY_PROPERTY}
          selectionContactIds={pendingContactIds}
          onSave={this.handleModalSave}
        />

        {/* checkDialerCampaignAccess only flips the redux flag; without this the
            Lead Automator upsell it triggers had nowhere to render, so clicking
            Dialer without the entitlement did nothing at all here. */}
        <LeadAutomatorUpgrade />

        {/* Rename Modal */}
        {showRenameModal && (
          <RenameListModal
            isOpen={showRenameModal}
            onClose={this.handleCloseRenameModal}
            onSave={this.handleSaveRename}
            title={renameConfig.title}
            description={renameConfig.description}
            initialValue={renameConfig.initialValue}
            placeholder={renameConfig.placeholder}
            checkOptions={renameConfig.checkOptions}
          />
        )}

        {isPropStream() &&
          (isAdmin && !this.props.isConnected ? (
            <BatchDialerModal
              isOpen={this.state.isBatchDialerModalOpen}
              onClose={this.closeBatchDialerModal}
            />
          ) : !showPushToBatchDialer || !this.props.isConnected ? (
                <BatchDialerAlert
                  isOpen={this.state.isBatchDialerModalOpen}
                  onClose={this.closeBatchDialerModal}
                  contactIds={this.state.selectedContactIds}
                />
              ) : (
                  <PushtoBatchDialer
                    isOpen={this.state.isBatchDialerModalOpen}
                    onClose={this.closeBatchDialerModal}
                    contacts={this.state.contactSearch}
                  />
          ))}

        {isPropStream() && this.shouldRenderClickToDial() && (
          <ClickToDial profile={this.props.profile} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const batchDialerList = selectBatchDialerList(state);
  const isConnected = Array.isArray(batchDialerList)
    ? batchDialerList.some((item) => item.externalSystem === 'BATCH_DIALER')
    : false;

  return {
    loading: selectLoading(state),
    pabEnabled: selectPabEnabled(state),
    groups: selectAssignableGroups(state),
    context: selectGroupContext(MAIN_CONTEXT)(state),
    appendGroups: selectAppendGroups(state),
    profile: selectProfile(state),
    isConnected,
    batchDialerList,
    userId: selectUserId(state),
    lmEnabled: selectListManagementEnabled(state),
    isLegacyAccount: isLegacyAccountPlan(state),
  };
};

const mapActionToProps = {
  saveGroupContext,
  exportContacts,
  updateAppendJob,
  updateContactGroup,
  getBatchDialerIntegration,
  setBatchDialerSource,
  openImport: ContactImport.open,
  openAddToGroup: AddToGroup.open,
  openMailingLabels: MailingLabelsPopup.open,
  prompt: Prompt.open,
  alert: Confirm.alert,
  showAlert: InfoAlert.open,
  skipTraceModal: SkipTraceModal.open,
  investorSkipTraceModal: InvestorSkipTraceModal.open,
  openAddToMarketingListModal: AddToMarketingListModal.open,
  leaveMessagePopup: LeaveMessagePopup.open,
  openAccountUpgrade: ActivateSubscriptionPopup.open,
  purchaseSavesAndExportsPopup: PurchaseSavesAndExportsPopup.open,
  getAppendJobEstimate,
  searchContactIds,
  createDialerCampaign,
  openLeadAutomatorUpgrade,
  loadCampaign,
  loadCampaigns,
  openFullAccessRequiredModal: FullAccessRequiredModal.open,
  closeFullAccessRequiredModal: FullAccessRequiredModal.close,
};

export default withRouter(connect(mapStateToProps, mapActionToProps)(ContactList));
